import { DatePipe } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ControlsComponent } from 'src/app/theme/controls/controls.component';

@Component({
  selector: 'calsoft-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent {


  daysList: any = [];
  dayMap: { [key: string]: number } = {};

  dayList: any = [];

  @Input() data: any;

  @Input() product: any;

  @Input() showCartIcon: any;

  @Input() showCartIncremented: any;


  @Input() buttonArray: any = [];


  @Input() configproduct: any = [];
  @Input() variant1Name: any;
  @Input() variant2Name: any;
  @Input() variant1Value: any;
  @Input() variant2Value: any;


  firstFormGroup: FormGroup;
  qty = 0;

  qtyFormControl = new UntypedFormControl(0);

  subscriptionType: any = [
    { "value": 0, "viewValue": "Daily" },
    { "value": 2, "viewValue": "Weekly" }
  ]

  weekDays: string[] = ['Su', 'M', 'Tu', 'W', 'TH', 'F', 'SA'];

  selectedWeekDays: string[] = [];

  todayDate: Date = new Date();
  today: Date = new Date();

  selectedDay: any;

  daysFormArray: FormArray;

  startDate: Date;

  endDate: Date;


  totalDateList: any = [];
  showType: boolean = false;
  showDay: boolean = false;
  qtyTotal: number = 0.0;

  initCartButton: boolean = false;
  maxDate: any;

  constructor(private _formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private datepipe: DatePipe,
    private dialog: MatDialog) { }


  @ViewChild('picker') picker: MatDatepicker<any>;


  ngOnInit(): void {
    this.initForm();

    this.confirm();
    // const maxDate = new Date();
    // maxDate.setDate(maxDate.getDate() + 30);
    // this.maxDate= this.datepipe.transform(maxDate, 'yyyy-MM-dd');


    //show only current month date
    // const lastDayOfMonth = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0); // 0 is the last day of the previous month
    // this.maxDate= this.datepipe.transform(lastDayOfMonth, 'yyyy-MM-dd');

    //show only current year date
    // const lastDayOfYear = new Date(this.today.getFullYear(), 11, 31);
    // this.maxDate= this.datepipe.transform(lastDayOfYear, 'yyyy-MM-dd');

   //show only 2 current year date
    // const maxDate = new Date(this.today.getFullYear() + 2, this.today.getMonth(), this.today.getDate());
    // this.maxDate= this.datepipe.transform(maxDate, 'yyyy-MM-dd');

    // const maxDate = new Date(this.today.getFullYear(), this.today.getMonth() + 3, this.today.getDate());
    // this.maxDate= this.datepipe.transform(maxDate, 'yyyy-MM-dd');

    const nextMonth = new Date(this.today.getFullYear(), this.today.getMonth() + 2, 0);
    this.maxDate= this.datepipe.transform(nextMonth, 'yyyy-MM-dd');
//     const currentDate = new Date(); // or any other date as per your requirement
// const currentMonthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // First day of the current month
// const currentMonthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0); // Last day of the current month
// const maxDate = this.maxDate(currentMonthStart); // Calculate max date based on the start of current month
// const minDate = this.minDate(currentMonthStart); // Calculate min date based on the start of current month
  }

  

  initForm() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1); // Set to tomorrow's date
    const endDate = new Date(tomorrow.getTime() + 0 * 24 * 60 * 60 * 1000);
    this.firstFormGroup = this._formBuilder.group({
      subscriptionId: [''],
      userId: [''],
      subscriptionType: ['Daily'],
      startDate: [tomorrow, Validators.required],
      endDate: [endDate, [Validators.required]],
      totalQuantity: [''],
      qty:[1],
      dayActivity: this._formBuilder.array([])
    });

    this.daysFormArray = this.firstFormGroup.get('dayActivity') as FormArray;
  }
  validateEndDate(control: AbstractControl) {
    if (!this.firstFormGroup) {
      return null; // or any appropriate action if the form is not initialized yet
    }

    const startDate = new Date(this.firstFormGroup.get('startDate').value);
    const endDate = new Date(control.value);
    if (endDate < startDate) {
      return { invalidEndDate: true };
    }
    return null;
  }




  pushObjectToDayActivity(day) {
    this.initCartButton = false;
    const dayActivityArray = this.firstFormGroup.get('dayActivity') as FormArray;
    const dayExistsIndex = dayActivityArray.controls.findIndex(control =>
      control.get('day').value === day
    );

    if (dayExistsIndex !== -1) {
      dayActivityArray.removeAt(dayExistsIndex);
    } else {

      const newDayActivityFormGroup = this._formBuilder.group({
        day: [day],
        qty: [1]
      });
      dayActivityArray.push(newDayActivityFormGroup);
    }
    this.submitFinal();

  }

  selectedDayValue(day) {
    const index = this.selectedWeekDays.indexOf(day);
    if (index === -1) {
      this.selectedWeekDays.push(day);
    } else {
      this.selectedWeekDays.splice(index, 1);
    }
  }


  removeDay(index: number) {
    this.daysFormArray.removeAt(index);
  }

  addDay(index, value) {
    const daysFormArray = this.firstFormGroup.get('dayActivity') as FormArray;
    const dayFormGroup = daysFormArray.at(index);
    dayFormGroup.get('qty').setValue(value);
  }


  increaseQtyNormal() {
    this.initCartButton = false;
    let qty = this.firstFormGroup.value.qty;
    qty++;

    this.firstFormGroup.get('qty').setValue(qty);

    this.submitFinal();
  }

  decreaseQtyNormal() {
    this.initCartButton = false;
    let qty = this.firstFormGroup.value.qty;
    qty--;

    if(qty<=0){
      this.snackBar.open('Qty Cannot be Lesser than Zero', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      qty=1;
    }
    
    this.firstFormGroup.get('qty').setValue(qty);
    this.submitFinal();

  }

  increaseQty(index) {
    this.initCartButton = false;
    let qty = this.firstFormGroup.value.dayActivity[index].qty;
    qty++;
    if (qty > 0) {
      const daysFormArray = this.firstFormGroup.get('dayActivity') as FormArray;
      const dayFormGroup = daysFormArray.at(index);
      dayFormGroup.get('qty').setValue(qty);
    }

    this.submitFinal();
  }

  decreaseQty(index) {
    this.initCartButton = false;
    let qty = this.firstFormGroup.value.dayActivity[index].qty;
    qty--;
    if (qty > 0) {
      const daysFormArray = this.firstFormGroup.get('dayActivity') as FormArray;
      const dayFormGroup = daysFormArray.at(index);
      dayFormGroup.get('qty').setValue(qty);
    } else {
      this.removeDay(index);
    }
    this.submitFinal();

  }

  submit() {

    if (this.firstFormGroup.valid) {
      this.calculateDaysCount();
    } else {
      console.log("error");
    }
  }


  selectedStartDate: Date;
  selectedEndDate: Date;
  selectedDaysCount: any = 0;
  init: boolean = false;
  map = new Map();

  calculateDaysCount() {
    this.selectedStartDate = this.firstFormGroup.get('startDate').value;
    this.selectedEndDate = this.firstFormGroup.get('endDate').value;

    // const timeDifference = Math.abs(this.selectedEndDate.getTime() - this.selectedStartDate.getTime());

    // const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    const start = new Date(this.selectedStartDate);
start.setHours(0, 0, 0, 0);

const end = new Date(this.selectedEndDate);
end.setHours(0, 0, 0, 0);

// Calculate the difference in milliseconds
const differenceInMs = end.getTime() - start.getTime();

// Convert milliseconds to days
const daysDifference = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
    this.dayList = [];
    this.weekDays.forEach(day => {


      this.dayMap[day] = 0

    });


    this.weekDays.forEach(obj => {

      this.map.set(obj, 0);
    });
    this.daysList = [];
    // Iterate over each day in the date range
    for (let i = 0; i <= daysDifference; i++) {
      const currentDate = new Date(this.selectedStartDate);
      currentDate.setDate(currentDate.getDate() + i);

      const currentDay = this.weekDays[currentDate.getDay()];
      this.dayMap[currentDay]++;
      this.init = true;

      let index = this.daysList.findIndex(x => x['day'] == currentDay);

      if (index == -1) {
        let list = [];
        list.push(currentDate)
        this.daysList.push({ day: currentDay, date: list });
      } else {

        this.daysList[index]['date'].push(currentDate);

      }

      this.totalDateList.push({ day: currentDay, date: currentDate })

    }

    if (this.firstFormGroup.value.subscriptionType == 'Daily') {



      this.setSubscriptionObject();




    }
  }



  confirm() {

    this.showType = true;

    if (this.firstFormGroup.value.subscriptionType == 'Daily') {
      this.totalDateList=[];
      this.calculateDaysCount()
    }


  }


  selectType(event, value) {

    if (event.isUserInput != false) {

      this.getDetails(value);
    }
  }


  getDetails(value) {
    this.initCartButton=false;
    this.firstFormGroup.get('subscriptionType').setValue(value);
    if (value == 'Weekly') {
      this.submit();
      this.showDay = true;
    } else if (value == 'Daily') {
     
      this.totalDateList=[];
      this.showDay = false;
      this.calculateDaysCount()
    }
    else {
      this.showDay = false;
    }
  }

  subscription: any = {
    subscriptionId: 0,
    userId: 0,
    subscriptionType: 1,
    totalQuantity: 0,
    operationType: 'Add',
    // Construct SubscriptionOccurrences if needed
    subscriptionOccurrences: [],
    cartItemId: 0,
    orderItemId: 0,
    productId: 0.0,
    price: 0.0,
    specialPrice: 0.0,
    totalValue: 0.0,
    totalQty: 0.0

  };

  submitFinal() {

    if (this.firstFormGroup.value.subscriptionType == 'Weekly') {


     

      if (this.firstFormGroup.value.dayActivity.length > 0) {



        this.setSubscriptionObject();




      } else {
        this.snackBar.open('Please Select Atleast One Day', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });

      }
    } else {

      this.setSubscriptionObject();

    }

    console.log(this.subscription);

  }

  setSubscriptionObject() {

    this.qtyTotal = 0.0;
    this.subscription.subscriptionOccurrences = [];

  

    if (this.firstFormGroup.value.subscriptionType == 'Weekly') {
      this.subscription.subscriptionType=2;
      this.firstFormGroup.value.dayActivity.forEach(element => {

        let day = element['day'];

        let qty = element['qty'];

        let index = this.daysList.findIndex(x => x['day'] == day);

        if (index >= 0) {



          if (this.daysList[index].date.length > 0) {



            this.daysList[index].date.forEach(dateObject => {

              this.qtyTotal = this.qtyTotal + qty;

              let object = {
                subscriptionOccurrenceId: 0,
                subscriptionId: 0,
                occurrenceDay: day,
                occurrenceDate: this.datepipe.transform(dateObject, 'yyyy-MM-dd'),
                quantity: qty,
                isActive: 1,
                isDelivered: 0,
                deliveryPeopleId: 0,
                productId: this.product['entityId'],
              }

              this.subscription.subscriptionOccurrences.push(object)

            });


          }


        }


      });
    } else {
      this.subscription.subscriptionType=1;
      this.totalDateList.forEach(element => {

        let day = element['day'];

        let qty = this.firstFormGroup.value.qty;

        this.qtyTotal = this.qtyTotal + qty;

        let object = {
          subscriptionOccurrenceId: 0,
          subscriptionId: 0,
          occurrenceDay: day,
          occurrenceDate: this.datepipe.transform(element.date, 'yyyy-MM-dd'),
          quantity: qty,
          isActive: 1,
          isDelivered: 0,
          deliveryPeopleId: 0,
          productId: this.product['entityId'],
        }

        this.subscription.subscriptionOccurrences.push(object)

      });

     


    }
    this.initCartButton = true;

    this.subscription.totalQty = this.qtyTotal;
    this.subscription.productId = this.product.entityId;
    this.subscription.price = this.product.price;
    this.subscription.specialPrice = this.product.specialPrice;

    if (this.subscription.specialPrice > 0) {
      this.subscription.baseSubtotal = this.subscription.price * this.subscription.totalQty;
      this.subscription.subtotal = this.subscription.specialPrice * this.subscription.totalQty;
    } else {
      this.subscription.baseSubtotal = this.subscription.price * this.subscription.totalQty;
      this.subscription.subtotal = this.subscription.price * this.subscription.totalQty;
    }

    this.subscription.startDate=this.datepipe.transform(this.firstFormGroup.value.startDate, 'yyyy-MM-dd');
    this.subscription.endDate=this.datepipe.transform(this.firstFormGroup.value.endDate, 'yyyy-MM-dd');

   
  }

  onDateRangeChange() {

    if (this.firstFormGroup.value.endDate != null) {

      this.getDetails(this.firstFormGroup.value.subscriptionType)
    }


  }

  getSub(event){
    console.log(event);

    if(event>0){
      
    }
    
  }


}
